import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { Order } from '../../../models/orderbook.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { StateService } from '../../../services/state.service';
import { OrderPipe } from '../../../helpers/order.pipe';
import { DataexchangeService } from '../../../services/dataexchange.service';
import { UserService } from '../../../services/user.service';
import { Trade } from '../../../models/trade';
import { CancelModalComponent } from '../../cancel-modal/cancel-modal.component';
import { Price } from '../../../models/price';
import { Direction } from '../../../models/direction';
import { Card } from '../../../models/card.model';
import { ModifyOrderModalComponent } from '../../modify-order-modal/modify-order-modal.component';
import {
  getAllOrdersSelector,
  getCurrencyMappingsSelector,
  getOnBehalfUsersSelector,
  getSelectedOnBehalfUserSelector,
  getSpotPricesSelector,
  getTopOrdersSelector,
} from '../../../store/state/selectors/matchboard.selectors';
import { Store } from '@ngrx/store';
import { MatchBoardState } from '../../../store/state/reducers/matchboard.reducers';
import { PriceService } from '../../../services/price.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-super-user-orderbook',
  templateUrl: './super-user-orderbook.component.html',
  styleUrls: ['./super-user-orderbook.component.scss'],
})
export class SuperUserOrderbookComponent implements OnInit, OnDestroy {
  subscriptions: Array<Subscription>;

  Tenors = [];

  OrderbookColumns: Order[] = [];
  users: any = {};
  modalRef: BsModalRef;
  public today = Date.now();

  // Table sort
  order: {
    timestamp?: number;
    sixLetterCode?: number;
    swap?: number;
    validity?: number;
    quantity?: number;
    profit?: number;
  } = {
    timestamp: -1,
    sixLetterCode: 1,
    swap: 0,
    validity: 0,
    quantity: 0,
    profit: 0,
  };
  reverse: boolean = false;
  // collection: any[] = this.OrderbookColumns;
  sortedCollection: any[];

  tzlocal = moment.tz.guess();
  serverTimeOffset = moment.tz('America/New_York').utcOffset(); // -300  New York UTC-5 hours
  localTimeoffset = moment.tz(this.tzlocal).utcOffset(); // 60
  localDif = this.localTimeoffset / 60;
  timeOffset =
    (this.serverTimeOffset - this.localTimeoffset) / 60 + this.localDif; // 420 / 7
  timeOff = this.timeOffset * 60;

  selectedOnBehalfUser: string;

  allOrders: any[];

  spotPrices: any;

  currencyMappings: any;

  topOrders: any;

  constructor(
    private readonly modalService: BsModalService,
    private httpService: HttpClient,
    private stateService: StateService,
    private orderPipe: OrderPipe,
    private dataexchangeService: DataexchangeService,
    private userService: UserService,
    private renderer: Renderer2,
    private readonly store: Store<MatchBoardState>,
    private readonly priceService: PriceService,
  ) {
    this.subscriptions = new Array<Subscription>();
  }

  openCancelModal(item: Order) {
    const initialState = {
      trade: new Trade(
        item.id,
        item.sixLetterCode,
        item.quantity,
        item.profit,
        item.profit,
        this.getCurrentMarket(item.sixLetterCode),
        0,
        'orderBook',
        item.direction,
        item.ocoLinkId,
      ),
      selectedTenorId: item.swap,
    };

    this.modalRef = this.modalService.show(CancelModalComponent, {
      ignoreBackdropClick: true,
      animated: true,
      backdrop: true,
      keyboard: true,
      class: 'modal-lg modal-cancel',
      initialState,
    });

    this.modalRef.content.closeBtnName = 'Close';
  }

  getCurrentMarket(sixLetterCode: string) {
    return this.priceService.getSpotPriceForCurrencyPair(
      this.spotPrices,
      this.currencyMappings,
      sixLetterCode,
    );
  }

  setOrder(value: string) {
    if (!Object.keys(this.order).includes(value) || this.order[value] === 0) {
      this.order[value] = 1;
      return;
    }

    if (this.order[value] === 1) {
      this.order[value] = -1;
      return;
    }
    this.order[value] = 0;
  }

  Arr = Array;
  num: number = 5;

  ngOnInit() {
    this.Tenors = [
      { id: 1, name: 'O/N', value: 'ON' },
      { id: 2, name: 'Ti', value: 'TI' },
      { id: 3, name: 'TOD-TOM', value: 'TOD_TOM' },
      { id: 4, name: '1w', value: 'W1' },
      { id: 5, name: '2w', value: 'W2' },
    ];

    this.store
      .select(getSelectedOnBehalfUserSelector)
      .subscribe((selectedUser) => {
        this.selectedOnBehalfUser = selectedUser;
      });

    this.store.select(getTopOrdersSelector).subscribe((topOrders) => {
      this.topOrders = topOrders;
    });

    this.store
      .select(getCurrencyMappingsSelector)
      .subscribe((currencyMappings) => {
        this.currencyMappings = currencyMappings;
      });

    this.store.select(getSpotPricesSelector).subscribe((spotPrices) => {
      this.spotPrices = spotPrices;
    });

    this.store.select(getAllOrdersSelector).subscribe((allOrders) => {
      if (!allOrders) {
        return;
      }
      this.OrderbookColumns = _.clone(Object.values(allOrders));
    });

    this.store.select(getOnBehalfUsersSelector).subscribe((onBehalfUsers) => {
      onBehalfUsers.forEach((u) => {
        this.users[u.id] = u;
      });
    });
  }

  getClass(property: string) {
    if (!this.order[property] || this.order[property] === 0) {
      return 'icon-with';
    }
    if (this.order[property] === -1) {
      return 'fa-chevron-up';
    }
    return 'fa-chevron-down';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  openModifyOrderModal(event) {
    const from = 'orderbook';
    this.renderer.addClass(document.body, 'modal-open');
    const card = new Card(event.sixLetterCode);
    card.swap = event.swap;
    const priceBorrow = this.getPricesForCurrencyPair(card, Direction.BORROW);
    const priceLend = this.getPricesForCurrencyPair(card, Direction.LEND);

    const spot = this.priceService.getSpotPriceForCurrencyPair(
      this.spotPrices,
      this.currencyMappings,
      event.sixLetterCode,
    );

    let swap = card.swap;
    if (swap === 'ON') {
      swap = 'O/N';
    }
    const initialState = {
      trade: new Trade(
        null,
        event.sixLetterCode,
        event.quantity,
        priceBorrow && priceBorrow[0] ? priceBorrow[0].price : 0,
        priceLend && priceLend[0] ? priceLend[0].price : 0,
        spot,
        event.quantity * spot,
        from,
        event.stpTradeDirection,
      ),
      order: event,
      ocoOrders: event.ocoLinkId
        ? this.allOrders.filter(
            (o) => o.ocoLinkId === event.ocoLinkId && o.ocoLinkId !== o.id,
          )
        : null,
      selectedTenorId: this.Tenors.find((t) => t.name.toUpperCase() === swap)
        .value,
    };

    this.modalRef = this.modalService.show(ModifyOrderModalComponent, {
      ignoreBackdropClick: true,
      animated: true,
      backdrop: true,
      keyboard: true, // enable Esc
      class: 'modal-lg modal-trade',
      initialState,
    });

    this.modalRef.content.closeBtnName = 'Close';
  }

  getPricesForCurrencyPair(card, direction): Array<Price> {
    const pricesForCurrencyPair = this.topOrders[card.sixLetterCode];
    if (!pricesForCurrencyPair) {
      return null;
    }

    const priceForCp = pricesForCurrencyPair[direction];
    if (priceForCp) {
      const prices = priceForCp.filter((p) => p.swap === card.swap);
      return prices.length > 0 ? prices : null;
    }

    return priceForCp;
  }
}
